// start:ng42.barrel
export * from './certainty-level.facade';
export * from './certainty-level.model';
// end:ng42.barrel

